import { useEffect } from "react";

export default function VerticalAds() {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.log(e);
    }
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: "block" }}
      data-ad-client="ca-pub-5162535306990850"
      data-ad-slot="3746920263"
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
}